/**
 * Envoltorio de tabla. Existe para que el scroll horizontal viva siempre en
 * el contenedor y nunca en el body: una grilla ancha no debe empujar la
 * página entera.
 */

import type { ReactNode } from 'react';

export function EnvoltorioTabla({
  children,
  pie,
}: {
  readonly children: ReactNode;
  /**
   * Pie de la tabla: el conteo, que deja de ser un `<p>` suelto debajo.
   *
   * Va como hermano de la grilla y no adentro: el envoltorio scrollea en
   * horizontal, y un pie adentro se corría junto con las columnas.
   */
  readonly pie?: ReactNode;
}): React.JSX.Element {
  if (pie === undefined) return <div className="tabla-envoltorio">{children}</div>;

  return (
    <div className="tabla-bloque">
      <div className="tabla-envoltorio">{children}</div>
      <div className="tabla-pie">{pie}</div>
    </div>
  );
}

/** Fila de "no hay nada", que dice qué hacer en lugar de quedar en blanco. */
export function FilaVacia({
  columnas,
  children,
}: {
  readonly columnas: number;
  readonly children: ReactNode;
}): React.JSX.Element {
  return (
    <tr>
      <td className="tabla-vacia" colSpan={columnas}>
        {children}
      </td>
    </tr>
  );
}
